import React, { useState } from 'react';
import StudentCallbacks from './StudentCallbacks';
import StudentActionsTable from './StudentActions';
import LocationMap from './LocationMap';
import StudentLead from './Studentlead'; 
import StudentFollowups from './StudentFollowups';

const StudentManagementDashboard = () => {
  const [activeTab, setActiveTab] = useState('leads'); // Change default tab to 'leads'

  const tabClasses = (tabName) => `
    px-4 py-2 text-sm font-medium border-b-2 
    ${activeTab === tabName 
      ? 'text-blue-600 border-blue-600' 
      : 'text-gray-500 border-transparent hover:border-gray-300'}
  `;

  return (
    <>
      {/* Tabs Navigation */}
      <div className="border-b border-gray-200 flex space-x-4">
        <button 
          onClick={() => setActiveTab('leads')}
          className={tabClasses('leads')}
        >
          Student Leads
        </button>
        <button 
          onClick={() => setActiveTab('followups')}
          className={tabClasses('followups')}
        >
          Student Followups
        </button>
        <button 
          onClick={() => setActiveTab('callbacks')}
          className={tabClasses('callbacks')}
        >
          Student Callbacks
        </button>
        <button 
          onClick={() => setActiveTab('actions')}
          className={tabClasses('actions')}
        >
          Student Actions
        </button>
        <button 
          onClick={() => setActiveTab('locations')}
          className={tabClasses('locations')}
        >
          Student Locations
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'leads' && <StudentLead />}
      {activeTab === 'followups' && <StudentFollowups />}
      {activeTab === 'callbacks' && <StudentCallbacks />}
      {activeTab === 'actions' && <StudentActionsTable />}
      {activeTab === 'locations' && <LocationMap />}
    </>
  );
};

export default StudentManagementDashboard;